<template>
  <div>
    <nav class="breadcrumb">
      <ul>
        <li><a @click.prevent="handleBreadcumb0()">cart</a></li>
        <li><a @click.prevent="handleBreadcumb1()">Location</a></li>
        <li>
          <a @click.prevent="handleBreadcumb2()" class="active">Delivery</a>
        </li>
        <li><a @click.prevent="handleBreadcumb2()">Payment</a></li>
      </ul>
    </nav>
    <main class="delivery-info">
      <div class="main-left">
        <div class="for-me">
          <p class="title">Enter Delivery Information</p>

          <div class="form-wrapper">
            <a-form
              class="form-container"
              layout="horizontal"
              :form="form"
              @submit="handleSubmit"
            >
              <a-form-item class="form-item">
                <a-button-group class="form-btn" @change="handleOrderFor">
                  <a-button
                    @click="
                      (activeClass = true), (display = 'none'), (forMe = true)
                    "
                    :class="{ active: activeClass }"
                  >
                    This is for Me
                  </a-button>
                  <a-button
                    @click="
                      (activeClass = !activeClass),
                        (display = 'block'),
                        (forMe = false)
                    "
                    :class="{ active: !activeClass }"
                  >
                    This is a Gift
                  </a-button>
                </a-button-group>
              </a-form-item>

              <a-form-item
                class="form-item"
                label="Receiver's Name"
                :validate-status="handleError('receiversname') ? 'error' : ''"
                :help="handleError('receiversname') || ''"
              >
                <a-input
                  v-decorator="[
                    'receiversname',
                    {
                      rules: [
                        {
                          required: true,
                          message: `Please input receiver's name!`,
                        },
                      ],
                    },
                  ]"
                  placeholder="Receiver's Name"
                />
              </a-form-item>

              <a-form-item
                class="form-item"
                label="Receiver's Mobile Number"
                :validate-status="handleError('receiversnumber') ? 'error' : ''"
                :help="handleError('receiversnumber') || ''"
              >
                <a-input
                  v-decorator="[
                    'receiversnumber',
                    {
                      rules: [
                        {
                          validator: checkPhoneNumber,
                          required: true,
                          message: `Please input receiver's mobile number!`,
                        },
                      ],
                    },
                  ]"
                  placeholder="Example: +977 9841000000"
                />
              </a-form-item>

              <a-form-item
                class="form-item"
                v-if="!forMe"
                label="Sender's Name"
                :validate-status="handleError('sendersname ') ? 'error' : ''"
                :help="handleError('sendersname') || ''"
              >
                <a-input
                  v-decorator="[
                    'sendersname',
                    {
                      rules: [
                        {
                          required: !this.forMe,
                          message: 'Please enter your name!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Sender's Name"
                />
              </a-form-item>

              <a-form-item
                class="form-item"
                v-if="!forMe"
                label="Sender's Email"
                :validate-status="handleError('sendersemail') ? 'error' : ''"
                :help="handleError('sendersemail') || ''"
              >
                <a-input
                  v-decorator="[
                    'sendersemail',
                    {
                      rules: [
                        {
                          validator: checkEmail,
                          required: !this.forMe,
                          message: 'Please enter your email!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Sender's Email"
                />
              </a-form-item>

              <a-form-item
                class="form-item"
                v-if="!forMe"
                label="How should we get in touch with you?"
              >
                <a-radio-group v-model="socialMedia" @change="handleSSMChange">
                  <a-radio :value="1"> Viber </a-radio>
                  <a-radio :value="2"> Whatsapp </a-radio>
                  <!-- <a-radio :value="3"> Messenger </a-radio> -->
                </a-radio-group>
              </a-form-item>

              <a-form-item
                class="form-item"
                v-if="!forMe && socialMedia === 1"
                label="Viber mobile number with country code"
                :validate-status="
                  handleError('senderssmusername') ? 'error' : ''
                "
                :help="handleError('senderssmusername') || ''"
              >
                <a-input
                  v-decorator="[
                    'senderssmusername',
                    {
                      rules: [
                        {
                          required: !this.forMe && socialMedia === 1,
                          message: 'Please enter your viber contact number!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Example: +61 0412 345 678"
                />
              </a-form-item>

              <a-form-item
                class="form-item"
                v-if="!forMe && socialMedia === 2"
                label="Whatsapp mobile number with country code"
                :validate-status="
                  handleError('senderssmusername') ? 'error' : ''
                "
                :help="handleError('senderssmusername') || ''"
              >
                <a-input
                  v-decorator="[
                    'senderssmusername',
                    {
                      rules: [
                        {
                          required: !this.forMe && socialMedia === 2,
                          message: 'Please enter your whatsapp contact number!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Example: +61 0412 345 678"
                />
              </a-form-item>

              <!-- <a-form-item label="Payment Mode :">
          <select class="select" v-model="paymentMethod">
            <option
              v-for="(item, index) in paymentOptions"
              :value="item"
              v-bind:key="index"
            >
              {{ item }}
            </option>
          </select>
        </a-form-item> -->

              <a-form-item class="form-item" label="Note">
                <a-textarea
                  v-decorator="[
                    'note',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Attach a note!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Note"
                />
              </a-form-item>

              <a-form-item
                class="form-item"
                label="Delivery Location"
                :validate-status="
                  handleError('deliverylocation') ? 'error' : ''
                "
                :help="handleError('deliverylocation') || ''"
              >
                <a-input
                  v-decorator="[
                    'deliverylocation',
                    {
                      rules: [
                        {
                          required: true,
                          message: `Please input your delivery address!`,
                        },
                      ],
                    },
                  ]"
                  placeholder="Delivery Location"
                />
              </a-form-item>

              <!-- <a-form-item class="form-item-button">
        <a-button
          class="submit-order-button"
          type="primary"
          html-type="submit"
          :disabled="hasErrors(form.getFieldsError())"
          >Submit Order</a-button
        >
      </a-form-item> -->
            </a-form>
          </div>

          <!-- <div class="form-btn">
            <button
              @click="(activeClass = true), (display = 'none')"
              :class="{ active: activeClass }"
            >
              THIS IS FOR ME
            </button>
            <button
              @click="(activeClass = !activeClass), (display = 'block')"
              :class="{ active: !activeClass }"
            >
              THIS IS A GIFT
            </button>
          </div>
          <form action="#" method="post">
            <div class="form-group">
              <label for="receiver's name"
                ><span>*</span> Receiver's Name</label
              >
              <input type="text" placeholder="Receiver's Name" required />
            </div>
            <div class="form-group">
              <label for="receiver's email"
                ><span>*</span> Receiver's Email</label
              >
              <input type="email" placeholder="Receiver's Email" required />
            </div>
            <div class="form-group">
              <label for="receiver's number"
                ><span>*</span> Receiver's Number</label
              >
              <input type="tel" placeholder="Receiver's Number" required />
            </div>
            <div :style="{ display: display }" class="is-gift">
              <div class="form-group">
                <label for="Sender's Name"><span>*</span> Sender's Name</label>
                <input type="text" placeholder="Sender's Name" />
              </div>
              <div class="form-group">
                <label for="senders's email"
                  ><span>*</span> Sender's Email</label
                >
                <input type="email" placeholder="Sender's Email" required />
              </div>
              <div class="form-group">
                <label for="Sender's Social Media"
                  ><span>*</span> Sender's Social Media</label
                >
                <div class="radio">
                  <input type="radio" name="media" id="viber" /> Viber
                  <input type="radio" name="media" id="whatsapp" /> Whatsapp
                  <input type="radio" name="media" id="messenger" /> Messenger
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="Delivery location"
                ><span>*</span> Delivery Location</label
              >
              <input type="text" placeholder="Receiver's Location" required />
            </div>
            <div class="form-group">
              <label for="note">Note</label>
              <textarea name="note" id="note"></textarea>
            </div>
          </form> -->
        </div>
      </div>
      <div class="main-right">
        <div class="order-summary">
          <p class="title">Order Summary</p>
          <div class="items-list">
            <div class="item" v-for="item in cartItems" :key="item.id">
              <div class="item-left">
                <img
                  v-if="!item.image"
                  class="cartListImg"
                  src="../../../assets/images/default-img.jpg"
                />

                <img
                  v-else
                  class="cartListImg"
                  :src="item.image"
                  :alt="item.name"
                />
              </div>
              <div class="item-right">
                <div class="item-name">
                  {{ item.name }}
                </div>
                <div class="item-qty">
                  NRs. {{ item.after_price }} X {{ item.quantity }}
                </div>
              </div>
            </div>
          </div>
          <div class="calculations">
            <p>Subtotal ({{ cartQuantity }} items)</p>
            <p>
              NRs.
              {{ this.cartTotal }}
            </p>
          </div>

          <!-- <button class="discount">
            <div class="discount-details-wrapper">
              <div class="discounts-info">
                <span
                  v-if="
                    this.getPromoInfo.description ||
                    this.getPromoInfo.cookedFood ||
                    this.getPromoInfo.mart ||
                    this.getPromoInfo.bakery ||
                    this.getPromoInfo.liquor ||
                    this.getPromoInfo.deliveryCharge
                  "
                  class="discounts-header"
                  >Coupon Discount Applied!</span
                >
                <span v-if="this.getPromoInfo.description">
                  {{ this.getPromoInfo.description }}
                </span>
                <span v-if="this.getPromoInfo.cookedFood > 0">
                  {{ this.getPromoInfo.cookedFood }}% Discount in Food Items.
                </span>
                <span v-if="this.getPromoInfo.mart > 0">
                  {{ this.getPromoInfo.mart }}% Discount in Mart Items.
                </span>
                <span v-if="this.getPromoInfo.bakery > 0">
                  {{ this.getPromoInfo.bakery }}% Discount in Bakery Items.
                </span>
                <span v-if="this.getPromoInfo.liquor > 0">
                  {{ this.getPromoInfo.liquor }}% Discount in Liquor Items.
                </span>
                <span v-if="this.getPromoInfo.deliveryCharge >= 0"
                  >Delivery Charge Rs
                  {{ this.getPromoInfo.deliveryCharge }}.</span
                >
              </div>
            </div>
          </button> -->

          <!-- <div
            class="category-price-container calculations"
            v-if="this.getPromoInfo.status === true"
          >
            <p class="category-text">Discount:</p>
            <div>
              <p class="category-price">
                NRs. {{ this.cartTotal - this.getPromoDiscountTotal }}
              </p>
            </div>
          </div> -->

          <div class="calculations">
            <p class="calculations__cartTotal">++ Delivery Charge</p>
            <!-- <p class="calculations__cartTotal">NRs. {{ deliveryCharge }}</p> -->
          </div>

          <!-- <div
            class="category-price-container calculations"
            v-if="this.vat !== 0"
          >
            <p class="category-text">VAT(13%):</p>
            <p class="category-price">NRs. {{ this.vat }}</p>
          </div>

          <div
            class="category-price-container calculations"
            v-if="this.intlTransfer !== 0"
          >
            <p class="category-text">International Transfer Charge(5.1%):</p>
            <p class="category-price">NRs. {{ this.intlTransfer }}</p>
          </div> -->

          <!-- <div class="total-price-container calculations">
            <p class="total-price">Total Amount:</p>


            <p class="total-price">
              NRs.
              {{
                (this.getPromoDiscountTotal === 0
                  ? this.cartTotal
                  : this.getPromoDiscountTotal) +
                this.deliveryCharge +
                this.vat +
                this.intlTransfer
              }}
            </p>


            <p class="total-price">
              NRs. {{ this.cartTotal + this.deliveryCharge }}
            </p>
          </div> -->
        </div>
        <div class="buttons">
          <a
            ><button @click.prevent="handleContinueShopping()">
              <a-icon type="shopping-cart" />ADD MORE ITEMS
            </button></a
          >
          <a>
            <button @click="handleSubmit()">CONFIRM DETAILS</button>
          </a>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { GetPaymentModes } from "../../../services/items.service";
import { LocationId, CartData } from "../../../services/storage.service";
import router from "../../../router";
import axios from "axios";
import { UserService } from "../../../services/user.service";

import WizardFooter from "../../../components/FloatingFooter/WizardFooter";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

export default {
  name: "DetailsForm",
  components: {
    WizardFooter,
  },
  data() {
    return {
      activeClass: true,
      display: "none",
      hasErrors,
      socialMedia: 1,
      socialMediaAccount: "Viber",
      forMe: true,
      orderFor: 0,
      cartQuantity: 0,
      delCharge: 0,
      smHandles: [
        {
          id: 1,
          name: "Viber",
          label: "Viber mobile number with country code",
        },
        {
          id: 2,
          name: "Whatsapp",
          label: "Whatsapp mobile number with country code",
        },
      ],

      newTotal: 0,
      intlTransfer: 0,
      vat: 0,

      promoInfo: {},

      paymentOptions: [],
      paymentMethod: "Cash",
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
      emailReg:
        /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  mounted() {
    this.getPaymentOptions();

    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });

    this.form.setFieldsValue({
      receiversname: this.loggedUser.hasOwnProperty("first_name")
        ? this.loggedUser.first_name
        : "",
      receiversnumber: this.loggedUser.hasOwnProperty("phone")
        ? this.loggedUser.phone
        : "",
      deliverylocation: this.loggedUser.hasOwnProperty("address")
        ? this.loggedUser.address
        : "",
      sendersname: "",
      sendersemail: "",
      senderssmusername: "",
      note: "",
    });
  },
  computed: {
    ...mapGetters([
      "cartItems",
      "loggedUser",
      "cartTotal",
      "getMinOrder",
      "deliveryCharge",
      "getPromoDiscountTotal",
      "getPromoDiscount",
      "getPromoInfo",
    ]),
  },
  methods: {
    ...mapActions([
      "addUserDetail",
      "updateStep",
      "addDiscount",
      "addCFDiscount",
      "addMDiscount",
      "addBDiscount",
      "addLDiscount",
      "addPromoCode",
      "applyDeliveryCharge",
      "setPromoInfo",
    ]),

    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },
    getPaymentOptions: function () {
      GetPaymentModes.getItems(LocationId.getLocationId())
        .then((response) => {
          this.paymentOptions = response.user;
        })
        .catch((err) => console.log(err));
    },
    handleSubmit() {
      if (this.hasErrors(this.form.getFieldsError()) === true) {
        // console.log(receiversnumber);
        this.$notification.error({
          message: "Empty Fields Submitted!",
          description: "Please fill out all required fields before submitting!",
        });
      }

      this.form.validateFields((err, values) => {
        if (!err && this.cartItems.length === 0) {
          this.$message.warning(
            "Cart Cannot be empty. \n Please select atleast one Item."
          );
        } else if (this.cartTotal < this.getMinOrder) {
          this.$message.warning(
            `"Cart should be atleast of NRs. ${this.getMinOrder} ."`
          );
        } else if (!err) {
          this.addUserDetail({
            values,
            sM: this.socialMediaAccount,
            orderFor: this.orderFor,
          });
        }
      });
    },
    handleOrderFor(e) {
      if (e.target.value == 0) {
        this.forMe = true;
      } else if (e.target.value == 1) {
        this.forMe = false;
      }
    },
    handleSSMChange(e) {
      if (e.target.value == 1) {
        this.socialMediaAccount = "Viber";
      } else if (e.target.value == 2) {
        this.socialMediaAccount = "Whatsapp";
      } else if (e.target.value == 3) {
        // this.socialMediaAccount = "Messenger";
      }
    },
    checkPhoneNumber(rule, value, callback) {
      if (value.length >= 10 && value.length <= 15) {
        callback();
        return;
      } else {
        callback("Please enter a valid phone number!");
      }
    },
    checkEmail(rule, value, callback) {
      if (this.emailReg.test(value)) {
        callback();
        return;
      } else {
        callback("Email is not valid!");
      }
    },
    handleContinueShopping() {
      router.push("/:loc?");
    },

    handleCheckout() {
      // alert('clicked');
      if (this.cartTotal < 500) {
        this.$message.warning(`"Cart should be atleast of NRs. 500."`);
      } else {
        this.updateStep(3);
      }
    },
    handleBreadcumb0() {
      this.updateStep(0);
      this.setPromoInfo(this.promoInfo);
      // window.location.reload();
    },
    handleBreadcumb1() {
      this.updateStep(1);
    },
    handleBreadcumb2() {
      this.updateStep(2);
    },
    getCartItemsCategories(e) {
      e.preventDefault();

      // cart items
      const cData = CartData.getCartItems();

      // adding item section
      let cartCat = cData.map((obj) => {
        const index = this.allItems.findIndex((el) => el["id"] == obj["id"]);
        const { section } = index !== 1 ? this.allItems[index] : {};

        return {
          ...obj,
          section,
        };
      });

      // group items according to category
      const groupCategories = cartCat.reduce((acc, cV) => {
        acc[cV.section] = acc[cV.section] || [];
        acc[cV.section].push(cV);
        return acc;
      }, Object.create(null));

      // calculate category total
      let totalObj = this.getCatTotal(groupCategories);

      // adding category discount %
      let discountObj = this.createDiscountObj();

      // merging two datasets
      let mergedObj = totalObj.map((item) => ({
        ...item,
        ...discountObj.find((innerItem) => innerItem.cat === item.cat),
      }));

      /* calculate cart total
        returns total if dis is empty
        returns discounted total if dis available
      */
      const catTotal = mergedObj.reduce(
        (sum, { cat_total, dis }) => sum + this.calcCatDiscount(cat_total, dis),
        0
      );

      this.newTotal = catTotal;
      this.addDiscount(catTotal);
    },

    async getItems() {
      let allData = [];
      let morePagesAvailable = true;
      let currentPage = 0;
      // https://manager.khaanpin.com/api/getitemsv2/

      while (morePagesAvailable) {
        currentPage++;
        const response = await axios.post(
          "https://deus.khaanpin.com/om/getitemsv2/",
          {
            loc_id: LocationId.getLocationId(),
            page: currentPage,
          }
        );

        let { data, page_count } = response.data;
        data.forEach((e) => allData.push(e));
        morePagesAvailable = currentPage < page_count;
      }

      const result = allData.map((data) => ({
        id: data.id,
        section: data.section,
      }));

      this.allItems = result;
    },
    createDiscountObj() {
      let disObj = [];

      disObj.push(
        { cat: "cooked-food", dis: this.promoInfo.cookedFood },
        { cat: "mart", dis: this.promoInfo.mart },
        { cat: "bakery", dis: this.promoInfo.bakery },
        { cat: "drinks", dis: this.promoInfo.liquor }
      );

      return disObj;
    },

    calcCatDiscount(total, discount) {
      // console.log(total, discount);
      const discountedPrice = Math.ceil(total - (discount / 100) * total);
      return discountedPrice;
    },
  },
  created() {
    window.scrollTo(0, 0);

    let quantity = this.cartItems.reduce((acc, item) => acc + item.quantity, 0);
    this.cartQuantity = quantity;
  },
  watch: {
    cartItems: function (val) {
      let quantity = val.reduce((acc, item) => acc + item.quantity, 0);
      this.cartQuantity = quantity;
    },
    getPromoDiscount: function (newDiscount, oldDiscount) {
      if (newDiscount > 0) {
        this.showDiscount = true;
      } else {
        this.showDiscount = false;
      }
    },
  },
  beforeMount() {
    // this.getUserRegion();
    this.getItems();
    this.getUserTimezone();
    this.getDeliveryCharge();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

// new css
// variables
$theme-color: #ed3c3b;
$font-color: #706b6b;
$detail-color: #333;
$success-color: #60b246;
$info-color: #2e89d3;

$button-size: 16px;
$text-size: 16px;
$icon-size: 20px;
$heading-size: 24px;
$display-size: 36px;

$border: 1px solid rgba(3, 3, 3, 0.3);
$border-radius: 10px;

nav {
  max-width: 60rem;
  margin: 0px auto 20px;
  ul {
    list-style: none;
    li {
      display: inline;
      + li:before {
        content: ">";
        padding: 10px;
      }
      a {
        text-decoration: none;
        color: $font-color;
        font-size: $icon-size;
        text-transform: uppercase;
        color: $font-color;
        padding: 5px 10px;
        &:hover {
          opacity: 0.8;
          transition: all ease-in-out 0.3s;
        }
      }
      .active {
        color: $theme-color;
        font-weight: bold;
      }
    }
  }
}
main {
  width: 60rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  grid-gap: 20px;
  hr {
    opacity: 0.3;
  }
  p {
    font-size: $text-size;
    color: $detail-color;
  }
  .main-left {
    .for-me {
      border-radius: $border-radius;
      padding: 20px;
      width: auto;
      height: 565px;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      border-radius: $border-radius;
      padding: 20px;
      width: auto;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      overflow-y: scroll;
      .title {
        font-size: $heading-size;
        font-weight: bold;
        color: $detail-color;
        margin-bottom: 20px;
        /*         position: sticky;
        top: 0; */
      }

      .form-btn {
        width: 100%;
        button {
          width: 50%;
          padding: 0px 0;
          background-color: #fff;
          border: 1px solid $theme-color;
          color: $theme-color;
          border-radius: $border-radius;
          font-size: $button-size;

          text-decoration: none;
          color: $theme-color;

          &:hover {
            background-color: $theme-color;
            cursor: pointer;
            transition: all ease-in-out 0.3s;

            color: #fff;
            transition: all ease-in-out 0.3s;
          }
          &:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
          &:last-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .active {
          background-color: $theme-color;

          color: #fff;
        }
      }
      form {
        .form-group {
          display: flex;
          flex-flow: column nowrap;
          margin: 10px 0;
          label {
            span {
              color: $theme-color;
            }
          }
          input {
            padding: 10px;
            outline: none;
            border: $border;
            font-size: $button-size;
            border-radius: $border-radius;
            color: #000;
          }
          textarea {
            resize: none;
            height: 175px;
            outline: none;
            border: $border;
            border-radius: $border-radius;
            padding: 10px;
            color: #000;
          }
        }
        .is-gift {
          .radio {
            display: flex;
            align-items: center;
            input[type="radio"]:not(:first-child) {
              margin-left: 40px;
            }
            input[type="radio"] {
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .main-right {
    .order-summary {
      border-radius: $border-radius;
      width: auto;
      padding: 20px 20px 8px;

      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      .title {
        font-size: $heading-size;
        color: $detail-color;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .items-list {
        height: 9rem;
        padding: 0 10px;
        margin-bottom: 10px;
        border: $border;
        border-radius: $border-radius;
        overflow-y: hidden;
        &:hover {
          overflow-y: scroll;
        }
        .item {
          display: flex;
          margin: 20px 0 10px;
          .item-left {
            img {
              height: 50px;
              width: 50px;
              border-radius: $border-radius;
              box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
            }
          }
          .item-right {
            margin-left: 20px;
            .item-name {
              font-size: $text-size;
              font-weight: bold;
            }
          }
        }
      }
      .calculations {
        display: flex;
        justify-content: space-between;
      }

      .calculations__cartTotal {
        width: 100%;
        text-align: end;
        font-size: 12px;
        color: rgb(100, 100, 100);
      }

      .discount {
        width: 100%;
        outline: none;
        border: none;
        color: $detail-color;
        margin-bottom: 10px;

        &:hover {
          cursor: default;
        }
        li {
          list-style: none;
        }
        span {
          display: block;
        }
        .discounts-header {
          padding: 10px 0;

          text-decoration: underline;
        }
        .discounts-info {
          // height: 0;
          // padding: 10px;
          // margin-bottom: 10px;
          font-size: $button-size;
          font-weight: bold;
          background-color: #ffff00;
        }
      }
    }
    .buttons {
      padding: 20px;
      margin-top: 20px;
      margin-bottom: 80px;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      border-radius: $border-radius;
      display: flex;
      flex-flow: column nowrap;
      a {
        &:not(:last-child) {
          margin-bottom: 20px;
        }
        &:last-child {
          button {
            background-color: $success-color;
            color: #fff;
          }
        }
        button {
          padding: 10px;
          width: 100%;
          font-size: $button-size;
          border-radius: $border-radius;
          border: $border;
          outline: none;
          color: $font-color;
          background-color: white;
          box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
          i {
            font-size: 20px;
            margin-right: 5px;
          }
          &:hover {
            cursor: pointer;
            transition: all ease-in-out 0.3s;
            box-shadow: none;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .breadcrumb {
    max-width: 50rem;
    margin: 0px auto 20px;
  }
  main {
    max-width: 50rem;
    .recommendation {
      .recommended-item {
        .cartList {
          .cartListInfo {
            margin: 0 30px;
            .cartListInfo-top {
              p {
                font-size: calc($text-size - 3px);
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1222px) {
  .breadcrumb {
    max-width: 35rem;
    margin: 0px auto 20px;
  }
  main {
    max-width: 35rem;
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 567px) {
  .breadcrumb {
    ul {
      margin-left: 20px;
      li {
        + li:before {
          padding: 2px;
        }
        a {
          padding: 5px;
          font-size: calc(var(--icon-size) - 4px);
        }
      }
    }
  }
  main {
    width: 90vw;
    margin: 0 auto;
    .main-left {
      .cart {
        width: 90vw;
        height: 430px;
        .cartList {
          img {
            height: 50px;
            width: 50px;
          }
          .cartListInfo {
            margin: 0 0px 0 20px;
            flex-basis: 0%;
            .cartListInfo-top {
              width: 10rem;
            }
            .cartListInfo-bottom {
              width: 250px;
            }
          }
        }
      }
      .recommendation {
        width: 90vw;
      }
    }
  }
  .recommendation {
    display: none;
  }
}

// old css
@mixin flexbox() {
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-info-wrap {
  margin-top: 80px;
  background: #fbfbfb;
  .order-button {
    margin-top: 0;
  }
}

.custom-form {
  width: 400px;
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
  .user-form {
    margin-bottom: 50px;
  }
}

.select {
  position: relative;
  font-family: $main-font;
  font-size: 14px;
  padding: 5px;
  height: 30px;
  border: 1px solid #d4d5d9;
  outline: none;
  width: 100%;
}

.form-wrapper {
  width: 100%;
  height: 450px;
  position: relative;
  display: inline-block;
  // background: #f2f2f2;
  // overflow-x: hidden;
  // overflow-y: scroll;
  padding-bottom: 30px;
}

.form-container {
  width: 100%;
  height: 100%;
  padding: 0px;
  font-family: $main-font;
  // display: inline-block;
  // position: relative;
}
.form-item {
  width: 100%;
  text-align: left;
  margin-bottom: 15px;
}
// .form-item-button {
//   align-self: center;
//   margin-top: 20px;
// }

.submit-order-button {
  padding: 10px;
  height: auto;
  cursor: pointer;
  font-family: $main-font;
  text-transform: uppercase;
  border-radius: 4px;
}

@media only screen and (max-width: 740px) {
  .form-container {
    width: 100%;
    padding: 20px 10px;
  }
  .form-item {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
}

.total-price {
  font-weight: 600;
  line-height: 22px;
}
</style>
